// DS: C25P
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileNativeDropdown from '../../MobileNativeDropdown';
import { updateSelectionByValue } from '../../helpers';
import FormDropdown, { Props as FormDropdownProps } from '../FormDropdown';
import s from './NumbersDropdown.scss';

export interface Props extends FormDropdownProps {
  /** If true, will use the NativeDropdown (select) for input */
  forceNativeDropdown?: boolean;
}

const NumbersDropdown: React.FC<Props> = ({
  menuClassName,
  menuLabelClassName,
  itemClassName,
  items,
  forceNativeDropdown,
  ...props
}) => {
  const isMobile = useContext(MobileContext);
  const placeholder =
    typeof props.placeholder === 'string' ? props.placeholder : '';
  const itemsWithSelection = updateSelectionByValue(props.selectedValue, items);

  // There'll only ever be one of these, so pull the last selected value
  const mobileTitle =
    itemsWithSelection
      .filter(item => 'selected' in item && item.selected)
      .reduce((accumulator, selection) => selection.label, null) || placeholder;

  return isMobile || forceNativeDropdown ? (
    <MobileNativeDropdown
      isLegacyFormInput
      className={s['toggle']}
      title={mobileTitle}
      titleClassName={menuLabelClassName}
      items={itemsWithSelection}
      {...props}
    />
  ) : (
    <FormDropdown
      withScrollableArrows
      withMenuPaddings={false}
      items={itemsWithSelection}
      {...props}
    />
  );
};
NumbersDropdown.displayName = 'NumbersDropdown';

export default NumbersDropdown;
